import _ from 'lodash';

export default {
    data() {
        return {
            isPatchingProposal: false,
            isCompletingProposal: false,
        }
    },
    computed: {
        taskParamId() {
            return this.$route.params.task_id;
        },
        task() {
            return _.get(this.proposal, 'tasks', []).find(task => {
                return task.id === this.taskParamId;
            });
        },
        job() {
            return _.get(this.proposal, 'jobs', []).find(job => {
                return job.contact_id === _.get(this.contact, 'id') && job.task_id === _.get(this.task, 'id');
            });
        },
        isJobDelivered() {
            return !!_.get(this.job, 'delivered_at');
        },
        jobHasInsights() {
            return !!_.get(this.job, 'insights_file_id');
        }
    }
}
